var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from '@mui/material';
import { useMemo, useRef } from 'react';
var DEFAULT_COUNTRY_CODE = '+1';
var cleanFormattingNumber = function (phoneFormatted) {
  var cleaned = phoneFormatted.replaceAll(/([^+\d])|((?<=[\d+])\+)/g, '');
  return /^(\+(\d+)?)?$/.exec(cleaned) ? cleaned : "+".concat(cleaned);
};
var formatPhoneNumber = function (phoneNumberString) {
  var _a, _b;
  if (!phoneNumberString) {
    return phoneNumberString;
  }
  var cleaned = cleanFormattingNumber(phoneNumberString);
  var matchFirst = (_a = cleaned.match(/.{1,2}/g)) !== null && _a !== void 0 ? _a : [];
  var match = (_b = matchFirst.slice(1).join('').match(/.{1,3}/g)) !== null && _b !== void 0 ? _b : [];
  var arr = [matchFirst[0]];
  var separation = ' ';
  for (var i = 0; i < match.length; i++) {
    arr.push(separation, match[i]);
    separation = i < 2 ? '-' : '';
  }
  return arr.join('');
};
export var PhoneInput = function (_a) {
  var _b = _a.value,
    value = _b === void 0 ? '' : _b,
    onChange = _a.onChange,
    props = __rest(_a, ["value", "onChange"]);
  var ref = useRef(null);
  var formattedValue = useMemo(function () {
    return formatPhoneNumber(value);
  }, [value]);
  var handleChange = function (event) {
    var _a = event.target,
      selectionEnd = _a.selectionEnd,
      newValue = _a.value;
    var cleanedValue = cleanFormattingNumber(newValue);
    if (cleanedValue !== value) {
      onChange === null || onChange === void 0 ? void 0 : onChange(cleanedValue);
      var newSelection_1 = Math.max(formatPhoneNumber(cleanedValue).length - newValue.length, 0) + (selectionEnd !== null && selectionEnd !== void 0 ? selectionEnd : 0);
      setTimeout(function () {
        var _a;
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setSelectionRange(newSelection_1, newSelection_1);
      });
    }
  };
  var handleFocus = function () {
    if (!value) {
      onChange === null || onChange === void 0 ? void 0 : onChange(DEFAULT_COUNTRY_CODE);
    }
  };
  var handleBlur = function () {
    if (value === DEFAULT_COUNTRY_CODE) {
      onChange === null || onChange === void 0 ? void 0 : onChange('');
    }
  };
  return _jsx(TextField, __assign({
    inputProps: {
      maxLength: 20
    },
    placeholder: "".concat(DEFAULT_COUNTRY_CODE, " xxx-xxx-xxxx")
  }, props, {
    inputRef: ref,
    value: formattedValue,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  }));
};